module.exports = __webpack_public_path__ + "img/banner-interactive-card-map.131f03df.jpg";